<template>
  <div class="send-result">
    <div class="send-result-top">
      <div class="result-icon">
        <span class="iconfont icon-tianxiexinxibuzhou"></span>
        <!-- <img class="img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/send-result.png"> -->
      </div>
      <div class="result-title">您的预约已发送!</div>
      <p class="result-desc">展商确认后即预约成功。系统会第一时间通知您，敬请留意通知！</p>

      <div class="result-btn active" @click="toInviteMine">查看我的预约</div>
      <div class="result-btn" @click="toHome">返回首页</div>
    </div>

    <div class="recommend-section" v-if="exhibitorList.length">
      <div class="recommend-title">
        <span class="line"></span>
        <span class="text">推荐展商</span>
      </div>

      <div class="invite-content">
        <div class="invite-card" v-for="(exhibitor, index) in exhibitorList" :key="exhibitor.id">
          <div class="invite-card-left">
            <img class="image" :src="exhibitor.logoImage || 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/invite-default-avatar.png'" />
          </div>
          <div class="invite-card-right">
            <div class="invite-name ellipsis-2">{{exhibitor.name}}</div>
            <div class="invite-site">{{exhibitor.exhibitionBoothNumber}}</div>
            <div class="invite-operate">
              <div class="invite-btn" :class="[exhibitor.invite ? 'invited' : '']" @click="bindInvite(exhibitor)">
                <template v-if="exhibitor.invite">
                  <span>已预约</span>
                </template>
                <template v-else>
                  <img class="image" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/icon-invite.png">
                  <span>预约洽谈</span>
                </template>
              </div>
              <div class="invite-collect" :class="[exhibitor.collected ? 'collected' : '']" @click="onCollect(exhibitor, index)">
                <span class="iconfont" :class="[exhibitor.collected ? 'icon-shoucang-xuanzhong' : 'icon-shoucang']"></span>
                <span class="span">{{exhibitor.collected ? '已收藏' : '收藏'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tip-section">
      <div class="tip-inner">
        <p class="tip-title">温馨提示：</p>
        <p class="tip-item">1、请到“我的预约”查看洽谈行程</p>
        <!-- <p class="tip-item">2、如有疑问，您可以联系平台客服：400-001-001</p> -->
        <p class="tip-item">2、如有疑问，您可以联系展会官方客服：4000587799；贾女士 13691555605</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  export default {
    data() {
      return {
        exhibitorList: []
      }
    },
    computed: {
      ...mapGetters(["id"]) // 展商id
    },
    created() {
      this.getExhibitorBrowseList()
    },
    methods: {
      getExhibitorBrowseList() {
        const params = {
          pageNum: 1,
          pageRows: 3,
          questionList: [],
          refreshAIData: true,
          appointExhibitorIdList: [this.id],
        }
        this.$http.browseListWithAI(params).then(res => {
          if (res.code === 1000) {
            this.exhibitorList = res.data.list
          }
        })
      },
      onCollect(item, index) {
        const params = {
          id: item.collectionId,
          collectionSubjectId: item.id,
          collectionSubjectType: 'ACTOR',
          deleted: item.collected
        }
        this.$http.addCollection(params).then(res => {
          if (res.code === 1000) {
            this.exhibitorList[index].collected = !this.exhibitorList[index].collected
          }
        })
      },
      toInviteMine() {
        // this.$router.push({
        //   path: '/invitation/mine'
        // })
        wx.miniProgram.navigateTo({
          url: '/pages/invitationList/index',
        })
      },
      toHome() {
        wx.miniProgram.switchTab({
          url: '/pages/invite/index'
        })
      },
      bindInvite(item) {
        console.log(item)

        // 已预约
        if (item.invite) {
          return
        }

        wx.miniProgram.navigateTo({
          url: '/pages/inviteSend/index?id=' + item.id,
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .send-result {
    padding: 12px 14px;
    .send-result-top {
      background: #FFFFFF;
      border-radius: 8px;
      padding: 40px 0;
      text-align: center;
      .result-icon {
        width: 50px;
        height: 50px;
        margin: 0 auto;
        .img {
          display: block;
          width: 100%;
          height: 100%;
        }
        .iconfont {
          font-size: 50px;
          color: var(--theme-color);
        }
      }
      .result-title {
        font-weight: 500;
        font-size: 20px;
        color: var(--theme-color);
        margin-top: 28px;
      }
      .result-desc {
        width: 224px;
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        margin: 8px auto 0;
      }
      .result-btn {
        width: 302px;
        padding: 8px 0;
        border-radius: 24px;
        font-weight: 600;
        font-size: 16px;
        margin: 20px auto 0;
        color: var(--theme-color);
        border: 1px solid var(--theme-color);
        &.active {
          background: var(--theme-color);
          color: #ffffff;
        }
      }
    }
    .recommend-section {
      .recommend-title {
        display: flex;
        align-items: center;
        margin: 16px 0;
        .line {
          display: inline-block;
          width: 3px;
          height: 16px;
          background: var(--theme-color);
          margin-right: 10px;
        }
        .text {
          font-weight: 600;
          font-size: 15px;
          color: #333333;
        }
      }
    }


    .invite-content {
      padding: 0 0 12px;
    }
    .invite-card {
      display: flex;
      background: #ffffff;
      padding: 10px;
      margin-bottom: 12px;
      border-radius: 4px;
    }
    .invite-card-left {
      width: 90px;
      height: 90px;
    }
    .invite-card-left .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .invite-card-right {
      flex: 1;
      padding-left: 12px;
      padding-top: 16px;
      padding-bottom: 5px;
      overflow: hidden;
    }
    .invite-name {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
    }
    .invite-site {
      width: 100%;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      margin-top: 8px;
      word-break: break-word;
    }
    .invite-operate {
      display: flex;
      margin-top: 12px;
    }
    .invite-btn {
      width: 100px;
      padding: 5px 15px;
      box-sizing: border-box;
      color: #ffffff;
      background: var(--theme-color);
      border-radius: 15px;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
    }

    .invite-btn.invited {
      background: #FFF5F0;
      color: var(--theme-color);
    }
    .invite-btn .image {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
    .invite-collect {
      width: 100px;
      padding: 5px 15px;
      box-sizing: border-box;
      border-radius: 15px;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #D9D9D9;
      font-weight: 500;
      color: #666666;
    }
    .invite-collect.collected {
      background: #F5F5F5;
      border: 1px solid #F5F5F5;
    }
    .invite-collect .iconfont {
      font-size: 15px;
      margin-right: 5px;
      color: #666666;
    }
    .invite-collect .icon-shoucang-xuanzhong {
      color: var(--theme-color);
    }
    .invite-collect .text {
      font-size: 13px;
    }

    .tip-section {
      .tip-title {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }
      .tip-item {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        margin-top: 0;
        margin-bottom: 6px;
      }
    }

  }
</style>
